export default "__VITE_ASSET__C6502Zlc__"